module.exports = __webpack_public_path__ + "img/members.f178949c.svg";